import styles from './PendingApplication.module.css';

const PendingApplication = () => {
    return (
        <div className={styles.pendingContainer}>
            <h2>We won’t be a minute!</h2>
            <p>
                Thanks for signing up to use iwocaPay! We just need to review
                your details. If we’ve received your request during working
                hours (Mon - Fri, 9am - 6pm) we’ll get back to you within a few
                hours, otherwise it will be within 2 hours of the next working
                day.
            </p>

            <p>
                Get in touch on{' '}
                <a className={styles.link} href="tel:0203 778 0549">
                    0203 778 0549
                </a>
                .
            </p>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default PendingApplication;
